<template>
    <div class="row m-0">
        <div class="col-12">
            <div class="row headers text-dark text-center py-3">
                <h2 class="h4 m-0 mx-auto"> {{ $t("contact_me") }} </h2>
            </div>
            <div class="row sections m-0">
                <div class="col-12 mt-2">
                    <p> {{ $t("contactText") }} </p>
                    <div id="contact-detail" class="text-left" :class="language === 'fa' ? 'rtl' : 'ltr'">
                        <p> <span class="mark"> <i class='bx bxs-map'></i> </span> {{ $t("contactPlace") }} </p>
                        <p> <span class="mark"> <i class='bx bx-at'></i> </span> abmohajeri1@gmail.com </p>
                        <p> <span class="mark"> <i class='bx bx-phone'></i> </span> {{ $t("mobile") }} </p>
                        <p> <span class="mark"> <i class='bx bx-cool'></i> </span> abmohajeri </p>
                    </div>
                    <div class="text-center mb-1">
                        <vs-button class="d-inline telegram-cta" href="https://t.me/a_m_log" blank gradient color="#229ED9">
                            <span class="btn-inner">
                                <i class='bx bxl-telegram'></i>
                                {{ $t("telegram_channel") }}
                            </span>
                        </vs-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";

    export default {
        name: "Contact",
        computed: {
            language() {
                return this.$i18n.locale;
            }
        },
        mounted() {
            let outer = this;
            $("#submitContact").on("click", function (e) {
                e.preventDefault();
                $("#contact-button-loading").removeClass("d-none");
                let email = $("#email").val();
                let text = $("#text").val();
                let captcha = $("#captchaTextBox").val();
                $.ajax({
                    url: '/contact.php',
                    method: "post",
                    data: {
                        email: email,
                        text: text,
                        captcha: captcha
                    },
                    success: function () {
                        outer.openNotification('bottom-center', 'success', 'Done, Your Message Sent');
                        $("#contact-button-loading").addClass("d-none");
                    },
                    error: function () {
                        outer.openNotification('bottom-center', 'danger', 'An Error Occurred, Please Try Again');
                        $("#contact-button-loading").addClass("d-none");
                    }
                })
            });
        },
        methods : {
            openNotification(position = null, color, text) {
                this.$vs.notification({
                    progress: 'auto',
                    color,
                    position,
                    title: text,
                    text: ``
                })
            }
        }
    }
</script>

<style>

</style>

<style scoped>
#contact-detail p {
    display: flex;
    align-items: center;
    gap: 10px;
}

.telegram-cta {
    font-weight: 600;
    border-radius: 10px;
}

.btn-inner {
    display: flex;
    align-items: center;
    gap: 6px;
}

.btn-inner i {
    font-size: 18px;
    transform: translateY(-1px);
}
</style>
